define('root/notifications/Podio.UI.Notifications',['require','jquery','lib/Podio.Event'],function(require) {

  var $ = require('jquery');
  var podioEvent = require('lib/Podio.Event');

  var state = {
    chunk: 1,
    per_chunk: null,
    isChunkLoading: false,
    notification_count: null,
    list_path: null,
    view: 'unviewed'
  };

  function resetState(chunk) {
    var list = $('#notification_list');
    state.per_chunk = list.data('state-limit');
    state.view = list.data('state-view');
    state.filter = list.data('state-filter');
    state.user_id = list.data('state-user-id');
    state.notification_count = list.data('notification-count');
    state.chunk = 1;
    state.isChunkLoading = false;
    state.list_path = $('#show_more_notifications').attr('href');
  }

  podioEvent.bind(podioEvent.Types.init, resetState);

  return {
    state: state
  };

});

